import axios from 'axios';

import atypes from '../../actions/actionTypes';
import { REST_API } from '../../common/constants';
import {getAuthorizedHeader} from '../../common/utils';

export const acceptInvitation = (auth, inviteId) => (dispatch) => {
    try {
        const headers = getAuthorizedHeader(auth);
        dispatch({type: atypes.ACCEPT_INVITATION_REQUEST});
        axios
            .post(REST_API + '/invites/accept', { id: inviteId }, { headers })
            .then((res) => {
                dispatch({type: atypes.ACCEPT_INVITATION_SUCCESS, payload: res.data});
            })
            .catch(function(err) {
                dispatch({type: atypes.ACCEPT_INVITATION_FAILURE, payload: err});
            });
    }
    catch (error) {
        const errorProps = {
            message: error.message,
        }
        dispatch({type: atypes.NO_TOKEN_FOUND, payload: errorProps});
    }
};